import { FC } from "react";
import { NavLink } from "react-router-dom";

interface BreadcrumbItem {
	label: string;
	to?: string;
	className?: string;
}

interface BreadcrumbProps {
	items: BreadcrumbItem[];
	className?: string;
}

const Breadcrumb: FC<BreadcrumbProps> = ({ items, className }) => {
	return (
		<nav aria-label="Breadcrumb">
			<ol className={`flex items-center gap-2 text-sm ${className ?? ""}`}>
				{items.map((item, index) => {
					const isLast = index === items.length - 1;

					return (
						<li key={index} className="flex items-center gap-2">
							{index > 0 && <span aria-hidden="true" className="opacity-50">›</span>}
							{item.to && !isLast ? (
								<NavLink to={item.to} className={`transition-colors hover:opacity-80 ${item.className ?? ""}`}>
									{item.label}
								</NavLink>
							) : (
								<span className={`${isLast ? "font-medium" : ""} ${item.className ?? ""}`}>{item.label}</span>
							)}
						</li>
					);
				})}
			</ol>
		</nav>
	);
};

export { Breadcrumb };
